import { Component, inject, OnInit, signal } from '@angular/core';
import { BrandProductsCreateComponent } from '../brand-products-create/brand-products-create.component';
import { ProductService } from '../../../../services/product/product.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { take } from 'rxjs';
import { ImageService } from '../../../../services/image/image.service';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { HasBoltOnDirectiveDirective } from '../../../../common/directives/has-bolt-on/has-bolt-on-directive.directive';
import { environment } from '../../../../../environments/environment';
import { UgcProductResponseDto } from '../../../../common/general-types/products.dto';

@Component({
  selector: 'mb-brand-products',
  standalone: true,
  imports: [BrandProductsCreateComponent, CurrencyPipe, HasBoltOnDirectiveDirective],
  // imports: [BrandProductsDrawerComponent  , CurrencyPipe],
  templateUrl: './brand-products.component.html',
  styleUrl: './brand-products.component.css'
})
export class BrandProductsComponent implements OnInit {

  environment = environment;

  showCreateProductModal = signal<boolean>(false);
  productToEdit = signal<UgcProductResponseDto | undefined>(undefined);
  allProducts = signal<UgcProductResponseDto[] | undefined>(undefined);
  
  private productService = inject(ProductService);
  private currentUserService = inject(CurrentUserService);
  public imageService = inject(ImageService);
  private router = inject(Router);
  
  ngOnInit(): void {
    this.getBusinessProducts();
  }

  getBusinessProducts() {
    this.productService.getbusinessProducts(this.currentUserService.focussedBrand.id).pipe(take(1)).subscribe((response) => {
      console.log('Products:', response);
      this.allProducts.set(response as UgcProductResponseDto[]);
    });
  }

  getProductTypeName(productTypeId: number) {
    let foundProduct = this.productService.allProductTypes.filter(pt => {
      if (pt.id == productTypeId) {
        return pt.name;
      } else {
        return;
      }
    })
    return foundProduct[0].name;
  }

  openCreateProductModal() {
    this.productToEdit.set(undefined);
    this.showCreateProductModal.set(true);
  }

  openEditProduct(product: UgcProductResponseDto) {
    this.productToEdit.set(product);
    this.showCreateProductModal.set(true);
  }

  closeProductModal() {
    this.showCreateProductModal.set(false);
    this.productToEdit.set(undefined);
  }

  onProductAdded(newProduct: UgcProductResponseDto) {
    this.closeProductModal();
    this.allProducts.update(list => [newProduct, ...(list ?? [])]);
  }

  onProductAmended(updated: UgcProductResponseDto) {
    this.closeProductModal();
    this.allProducts.update(list =>
      (list ?? []).map(p => (p.id === updated.id ? updated : p)),
    );
  }

  goToRakutenProducts(action: 'find' | 'list') {
    this.router.navigate(['/rakuten-products', action]);
  }

}
